import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import CitrusAdTracker from '../services/CitrusAdTracker';

export default class CitrusAdImpression extends PureComponent {
  static propTypes = {
    adId: PropTypes.string.isRequired,
  };

  componentDidMount = () => {
    this.recordCitrusImpression();
  };

  componentDidUpdate = () => {
    this.recordCitrusImpression();
  };

  recordCitrusImpression = () => {
    const { adId } = this.props;
    CitrusAdTracker.reportImpression({ adId });
  };

  render = () => null;
}
